<template>
    <div class='container' ref="containerBox" @scroll="handleScroll">
        <div ref="stickyBox" :class="[{ sticky: isSticky }, { box: !isSticky }]"
            :style="{ background: isSticky ? '#fff' : 'transparent' }">
            <titlePage :isSticky="isSticky" :scrollToTop="scrollToTop"></titlePage>
        </div>
        <div class='contentBox'>
            <div class="content">
                 <notice-page></notice-page>
                <div class="topcontent">
                    <div style="margin-top: 30px;background:#fff ;padding:  20px 0 10px 20px;border-radius: 8px;"
                        class="flex-around">
                        <div class="tags flex-column">
                            <p>已接订单数</p>
                            <p>{{ num.data_1 || 0 }}</p>
                        </div>
                        <div class="tags flex-column">
                            <p>面试人数</p>
                            <p>{{ num.data_2 || 0 }}</p>
                        </div>
                        <div class="tags flex-column">
                            <p>Offer人数</p>
                            <p>{{ num.data_3 || 0 }}</p>
                        </div>
                        <div class="tags flex-column">
                            <p>入职人数</p>
                            <p>{{ num.data_4 || 0 }}</p>
                        </div>
                        <div class="tags flex-column">
                            <p>过保人数</p>
                            <p>{{ num.data_5 || 0 }}</p>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 40px;" class="flex-between">
                    <el-tabs v-model="searchForm.type" @tab-click="handleClick">
                        <el-tab-pane label="已接订单" name="1"></el-tab-pane>
                        <el-tab-pane label="收藏订单" name="2"></el-tab-pane>
                    </el-tabs>
                    <!-- <div class="serchBox flex-center">
                    <el-input placeholder="请输入内容" v-model="searchForm.keyword" clearable>
                        <template slot="prepend">
                            <div class="cursor">全国<i class="el-icon-caret-bottom"></i></div>
                        </template>
</el-input>
<el-button type="primary" icon="el-icon-search">搜索</el-button>
</div> -->
                    <el-input placeholder="请输入内容" v-model="searchForm.keyword" class="input-with-select"
                        style="width: 60%;border:2px solid #0092FF;border-radius: 4px;">
                        <!-- <el-select v-model="select" slot="prepend" placeholder="请选择" style="background-color: #fff;">
                            <el-option label="全国" value="1"></el-option>
                            <el-option label="订单号" value="2"></el-option>
                            <el-option label="用户电话" value="3"></el-option>
                        </el-select> -->
                        <el-button slot="append" icon="el-icon-search" type="primary"
                            style="background: #0092FF;color: #fff;" @click="search()">搜索</el-button>
                    </el-input>
                </div>
                <div class="list-box flex-column" style="margin-top: 30px;">
                    <div class="list-item cursor boxShadow"
                        style="display: flex; flex-direction: column;padding: 0;margin-right: 0;"
                        v-for="(item, index) in list" :key="index" @click="getDetailes(item)">
                        <div class="card">
                            <div class="title">{{ item.title || '' }}</div>
                            <div class="flex-between">
                                <div class="flex" style="margin-top: 10px;">
                                    <div style="margin-right: 10px;" class="PriceText"> 20-40w/年 </div>
                                    <div class="tags tagsBorder">招{{ item.people || 0 }}人</div>
                                    <div class="tags tagsBorder">{{ item.city_name || '' }}</div>
                                    <div class="tags tagsBorder">{{ item.company || '' }}</div>
                                </div>
                                <div class="flex" style="margin-top: 10px;">
                                    <div class="tags flex-column" style="padding: 0 20px;">
                                        <p>{{ item.status_1 || 0 }}</p>
                                        <p>简历</p>
                                    </div>
                                    <div class="tags flex-column tagsBorder" style="padding: 0 20px;">
                                        <p>{{ item.status_2 || 0 }}</p>
                                        <p>面试</p>
                                    </div>
                                    <div class="tags flex-column tagsBorder" style="padding: 0 20px;">
                                        <p>{{ item.status_3 || 0 }}</p>
                                        <p>offer</p>
                                    </div>
                                    <div class="tags flex-column tagsBorder" style="padding: 0 20px;">
                                        <p>{{ item.status_4 || 0 }}</p>
                                        <p>入职</p>
                                    </div>
                                    <div class="tags flex-column tagsBorder" style="padding: 0 20px;">
                                        <p>{{ item.status_5 || 0 }}</p>
                                        <p>过保</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="GradientBackground flex-between" style="border-radius: 0 0 10px 10px;">
                            <div class="flex">
                                <div class="price" style="margin-right: 20px;">固定金额 {{ item.pay_fee || '' }}</div>
                                <div>{{ item.pay_list || '' }}</div>
                            </div>
                            <div class="text" style="color: #ADADAD;">{{ item.create_time || '' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <fotterVue></fotterVue>
        <TrialExpireRemindHost page-key="MyOrder" />
    </div>
</template>

<script>
import titlePage from '@/components/titlePage.vue';
import fotterVue from '@/components/fotter.vue';
import noticePage from '@/components/noticePage3.vue'
import TrialExpireRemindHost from '@/components/TrialExpireRemindHost.vue'
export default {
    name: '',
    components: {
        titlePage,
        fotterVue,
        noticePage,
        TrialExpireRemindHost,
    },
    data() {
        return {
            searchForm: {
                keyword: "",
                page: 1,
                size: 10,
                type: '1',
            },
            select: "1",
            loading: false,
            list: [],
            num: {},
            isSticky: false,
            stickyBoxTop: 0,
            isStatus: true,
        };
    },
    computed: {},
    watch: {},
    methods: {
        handleScroll(event) {
            const scrollTop = event.target.scrollTop
            this.isSticky = scrollTop > this.stickyBoxTop;
            const bottomOfWindow = this.$refs.containerBox.scrollHeight - this.$refs.containerBox.scrollTop - this.$refs.containerBox.clientHeight
            console.log(bottomOfWindow);
            if (this.isStatus == true && bottomOfWindow <= 50) {
                this.searchForm.page += 1
                this.isStatus = false
                this.getMyOrderpayList()
            }
        },
        scrollToTop() {
            this.$refs.containerBox.scrollTop = 0;
        },
        handleClick(tab, event) {
            console.log(tab, event, this.searchForm.type);
            this.searchForm.page = 1
            this.getMyOrderpayList()
        },
        getDetailes(item) {
            // this.$router.push('/MyOrderDetails'); 
            this.$router.push({
                path: '/MyOrderDetails', query: {
                    id: item.id
                }
            });
        },
        getMyOrderpayList() {
            if (this.searchForm.page == 1) {
                this.list = []
            }
            this.$api.index.getMyOrderList(this.searchForm).then(res => {
                console.log(res, '666');
                this.loading = false
                if (res.code == 200) {
                    this.list = [...this.list, ...res.data.list]
                    this.isStatus = res.data.total > this.list.length ? true : false
                    this.num = res.data.num
                }
            })
        },
        search() {
            this.searchForm.page = 1
            this.getMyOrderpayList()
        }
    },
    created() {

    },
    mounted() {
        this.scrollToTop()
        this.getMyOrderpayList()
    },
}
</script>
<style lang='scss' scoped>
.contentBox {
    background: linear-gradient(0deg, #F6F8FE 0%, #F6F8FE 78%, #CEEAFF 100%);
    margin-top: 60px;
    min-height: 55vh;
}

.content {
    padding: 30px 0;
}

.serchBox {
    width: 70%;
    border: 2px solid #0092FF;
    border-radius: 6px;
}

.topcontent {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    margin-top: 30px;

    .tags {
        margin: 0 20px;

        p {
            font-weight: 400;
            font-size: 14px;
            color: #333333;

            &:last-child {
                font-weight: bold;
                font-size: 24px;
                color: #333333;
            }
        }
    }

    ::v-deep input {
        background: rgb(245, 246, 250) !important;
        color: #000;
    }


    ::v-deep .el-input__inner {
        border-color: rgb(245, 246, 250) !important;
    }
}

.tags {
    padding: 0 10px;
    font-weight: 300;
    font-size: 14px;
    color: #333333;

    p {
        margin: 0;
        padding: 0;

        &:last-child {
            color: #666;
        }
    }
}

.tagsBorder {
    border-left: 1px solid #D7D7D7;
}

::v-deep .el-tabs__nav-wrap::after {
    background-color: transparent !important;
}

::v-deep .el-tabs__active-bar {
    background-color: transparent !important;
}

::v-deep .el-select .el-input {
    width: 120px;
} 
::v-deep .el-input-group__append {
    // background: rgb(42, 163, 254) !important; 
    position: relative;
    width: 90px;

    .el-button {
        position: absolute;
        // top: 10px;
        // margin-top: -10px;
        top: 7px;
        right: 19px;
        height: 44px;
        width: 91px;
    }
}
</style>